import {NgModule} from '@angular/core';
import {DashboardEffects} from '@caroo/dashboard/effects/dashboard.effects';
import {reducer as dashReducer} from '@caroo/dashboard/reducers/dashboard.reducer';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';

@NgModule({
	imports: [
		StoreModule.forFeature('dashboard', dashReducer),
		EffectsModule.forFeature([DashboardEffects]),
	]
})
export class DashboardStateModule {
}
